import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "upsell-cta",
    templateUrl: "upsell-cta.html",
    styleUrls: ["upsell-cta.scss"],
})

export class UpsellCTAComponent {
  @Input() productName: string = '';
  @Input() buttonYesText: string = 'Yes I want this special added to my order';
  @Input() buttonNoText: string = 'No thanks, I understand that I won\'t see this offer again';
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();
  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }
}
